var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LeftSideBar d-flex flex-column flex-shrink-0 h-100"},[_c('div',{staticClass:"LeftSideBar__main d-flex flex-column p-4 flex-grow-1"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }